import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../common/api-response.types';

export interface CreateQuotationDto {
  branchId: number;
  currencyFromId: number;
  currencyToId: number;
  fromAmount?: number;
  toAmount?: number;
  collectionScheduleStart?: string;
  collectionScheduleEnd?: string;
  promotionId?: number;
  inventoryAmount?: number;
}

@Injectable({
  providedIn: 'root',
})
export class QuotationsService {
  private readonly quotationsEndpoint = '/quotations';

  constructor(private readonly httpClient: HttpClient) {}

  public createQuotation(
    body: CreateQuotationDto
  ): Observable<ApiResponse<any>> {
    return this.httpClient
      .post<ApiResponse<any>>(
        `${environment.BASE_URL}${this.quotationsEndpoint}`,
        body
      )
      .pipe(
        map((response: ApiResponse<any>) => {
          return response;
        })
      );
  }
}
